import { Injectable, EventEmitter } from '@angular/core';
// import { User } from '../../models/user.model';
// import { UsuarioService } from '../usuario/usuario.service';
import moment from 'moment';

@Injectable()
export class CompartilhadoService {

  public esconderLoading: boolean = false
  //public usuario: User;
  public token: string;
  //public usuarioService: UsuarioService;

  public ocultarMenu: boolean = false;

  constructor() { }

  // estaLogado(): boolean {
  //   return this.usuario != null && this.usuario.nome !== '';
  // }

  public download(arquivo) {
    let doc = 'data:' + arquivo.tipo + ';base64,' + arquivo.conteudo;
    let mywindow = window.open('', '_blank');
    let element: any = document.createElement('a');
    element.setAttribute('href', '' + encodeURI(doc));
    element.setAttribute('download', arquivo.nome);
    mywindow.document.write(element);
    element.click();
    mywindow.close();
  }

  public formataValorDecimal(valor: string, casasDecimais: number): string {
    const valorSplit = valor.split(',');
    const valorAntesVirgula = valorSplit[0];
    let valorDepoisVirgula = '00';

    if (valorSplit.length > 1) {
        valorDepoisVirgula = valorSplit[1].substring(0, casasDecimais);
    }

    if (valorDepoisVirgula.length < casasDecimais) {
        const casasDecimaisFaltando = casasDecimais - valorDepoisVirgula.length;
        for (let i = 0; i < casasDecimaisFaltando; i++) {
            valorDepoisVirgula += '0';
        }
    }

    return `${valorAntesVirgula},${valorDepoisVirgula}`;
}

  public obterDataAtual(): string {
    const dia = new Date().getDate();
    const dataAtual = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        dia
    )
        .toISOString()
        .substring(0, 10);
    return dataAtual;
  }

  public comparaData(date1: any, date2: any): boolean {
    let aux1 = moment(date1).format()
    let aux2 = moment(date2).format()

    const d1 = moment(aux1, 'YYYY-MM-DD')
    const d2 = moment(aux2, 'YYYY-MM-DD');

    if(moment(d1).isSameOrAfter(d2))
      return false;
    else
      return true;
  }

  public datasIguais(date1: any, date2: any): boolean {
    let aux1 = moment(date1).format()
    let aux2 = moment(date2).format()

    const d1 = moment(aux1, 'YYYY-MM-DD')
    const d2 = moment(aux2, 'YYYY-MM-DD');

    if(moment(d1).isSame(d2))
      return true;
    else
      return false;
  }

  public validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') {
        return false;
    }

    if (cnpj.length !== 14) {
      return false;
    }

    if (
        cnpj === '00000000000000' ||
        cnpj === '11111111111111' ||
        cnpj === '22222222222222' ||
        cnpj === '33333333333333' ||
        cnpj === '44444444444444' ||
        cnpj === '55555555555555' ||
        cnpj === '66666666666666' ||
        cnpj === '77777777777777' ||
        cnpj === '88888888888888' ||
        cnpj === '99999999999999'
    ) {
      return false;
    }

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
          pos = 9;
      }
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) {
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
          pos = 9;
      }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) {
      return false;
    }

    return true;
  }

  public mascaraCnpj(valor) {
    return valor.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
        '$1.$2.$3/$4-$5'
    );
  }

  public validarCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '') {
        return false;
    }

    if (
      cpf.length != 11 ||
      cpf === '00000000000' ||
      cpf === '11111111111' ||
      cpf === '22222222222' ||
      cpf === '33333333333' ||
      cpf === '44444444444' ||
      cpf === '55555555555' ||
      cpf === '66666666666' ||
      cpf === '77777777777' ||
      cpf === '88888888888' ||
      cpf === '99999999999'
    ) {
        return false;
    }

    let add = 0;
    for (let i = 0; i < 9; i++) {
      add += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) {
      rev = 0;
    }
    if (rev != parseInt(cpf.charAt(9))) {
      return false;
    }

    add = 0;
    for (let i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) {
      rev = 0;
    }
    if (rev != parseInt(cpf.charAt(10))) {
      return false;
    }
    return true;
  }

  public validaEmail(email: string): boolean {
    if (email === '') {
      return false;
    }

    const pattern = /^\w+([.-]?\w+)@\w+([.-]?\w+)(.\w{1,3})$/;
    const estaValido = pattern.test(email);
    return estaValido;
  }

  public replaceSpecialChars(str: string) {
    str = str.replace(/[ÀÁÂÃÄÅ]/, 'A');
    str = str.replace(/[àáâãäå]/, 'a');
    str = str.replace(/[ÈÉÊË]/, 'E');
    str = str.replace(/[Ç]/, 'C');
    str = str.replace(/[ç]/, 'c');
    return str.replace(/[^a-z0-9]/gi, '');
  }

}
